import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/services/auth.services'; // Caminho correto para o AuthService
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root' // Disponibiliza o serviço globalmente
})
export class AuthGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.ensureAuthenticated().then((authenticated) => {
      if (authenticated) {
        return true; // Sessão válida (token vigente o renovado), permite acesso
      }
      // Sin sesión válida, redireciona para a página de login
      return this.router.createUrlTree(['/login']);
    });
  }
}
